import React, {useContext, useEffect, useState} from "react";
import PrintLogo from "../../common/PrintLogo";
import Img from "../../../common/Img";
import MoheLogo from "../../common/MoheLogo";
import db from "../../../../services/query";
import queryString from "query-string";
import ResultTable from "./_ResultTable";
import ResultSignatureArea from "./_ResultSignatureArea";
import ResultClassInfo from "./_ResultClassInfo";
import ResultClassSummary from "./_ResultClassSummary";

const ClassResultSummary = (props) => {

    const [data, updateData] = useState({});
    const [subjects, updateSubjects] = useState({});

    useEffect(async () => {

        const ac = new AbortController();

        requestData();
        return () => ac.abort();
    }, []);

    const requestData = async () => {
        const {classId} = props.match.params;

        await db.getAll(`results/resultBook/${classId}`).then(({data}) => {
            updateData(data);


            var semester_subjects = {};

            for (let student of data.data) {
                for (let subject of student.subjects[0]) {
                    var old_students = semester_subjects[subject.subject_name]?.students || [];
                    var final_total = subject.final_total;
                    semester_subjects[subject.subject_name] = {
                        subject,
                        "students": [...old_students, {...student, final_total}]
                    };
                }
            }
            updateSubjects(semester_subjects);
        });
    };

    return (
        <main className={`main-print-wrapper class-result-book class-result-summary-print`}>
            {/* Header */}
            <div className="print-header">
                <PrintLogo/>
                <div style={{textAlign: "center", minWidth: "35%"}}>
                    {/*<p>جمهوری اسلامی افغانستان</p>*/}
                    <p>وزارت تحصیلات عالی</p>
                    <p>معاونیت امورمحصلان</p>
                </div>
                <MoheLogo/>
            </div>



            {/* Class Info */}
            <ResultClassInfo class_info={data?.summary?.class_info}/>


            <ResultClassSummary class_info={data?.summary?.class_info} />

            <div style={{margin: "50px"}}></div>

            {data.data && <ResultTable students={data.data} subjects={subjects}/>}

            {/* Signature area */}
            <ResultSignatureArea class_info={data?.summary?.class_info}/>
        </main>
    );
};

export default ClassResultSummary;
